import React, { useState } from 'react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';

const Calendar = ({ onDateSelect, selectedDate }) => {
  const [currentMonth, setCurrentMonth] = useState(new Date());

  const getDaysInMonth = (date) => {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
  };

  const getFirstDayOfMonth = (date) => {
    return new Date(date.getFullYear(), date.getMonth(), 1).getDay();
  };

  const handlePreviousMonth = () => {
    setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1));
  };

  const handleNextMonth = () => {
    setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1));
  };

  const handleSelectDate = (day) => {
    const selected = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), day);
    // Formatta come YYYY-MM-DD usando la data locale (non UTC)
    const year = selected.getFullYear();
    const month = String(selected.getMonth() + 1).padStart(2, '0');
    const dayStr = String(selected.getDate()).padStart(2, '0');
    const formatted = `${year}-${month}-${dayStr}`;
    onDateSelect(formatted);
  };

  const daysInMonth = getDaysInMonth(currentMonth);
  const firstDay = getFirstDayOfMonth(currentMonth);
  const days = [];

  // Giorni del mese precedente (grayed out)
  const prevMonthDays = getDaysInMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1));
  for (let i = firstDay - 1; i >= 0; i--) {
    days.push({ day: prevMonthDays - i, currentMonth: false });
  }

  // Giorni del mese corrente
  for (let i = 1; i <= daysInMonth; i++) {
    days.push({ day: i, currentMonth: true });
  }

  // Giorni del mese successivo (grayed out)
  const remainingDays = 42 - days.length; // 6 weeks * 7 days
  for (let i = 1; i <= remainingDays; i++) {
    days.push({ day: i, currentMonth: false });
  }

  const monthName = currentMonth.toLocaleString('it-IT', { month: 'long', year: 'numeric' });

  // Verificazione se una data è oggi o passata
  const isDateDisabled = (day, isCurrentMonth) => {
    if (!isCurrentMonth) return true;
    const checkDate = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), day);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return checkDate < today;
  };

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <div className="flex justify-between items-center mb-6">
        <h3 className="text-lg font-bold text-gray-800">{monthName}</h3>
        <div className="flex gap-2">
          <button
            onClick={handlePreviousMonth}
            className="p-2 hover:bg-gray-100 rounded"
          >
            <FiChevronLeft size={20} />
          </button>
          <button
            onClick={handleNextMonth}
            className="p-2 hover:bg-gray-100 rounded"
          >
            <FiChevronRight size={20} />
          </button>
        </div>
      </div>

      {/* Intestazione giorni della settimana */}
      <div className="grid grid-cols-7 gap-2 mb-2">
        {['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'].map(day => (
          <div key={day} className="text-center font-semibold text-gray-600 py-2 text-sm">
            {day}
          </div>
        ))}
      </div>

      {/* Grid dei giorni */}
      <div className="grid grid-cols-7 gap-2">
        {days.map((dayObj, index) => {
          const isDisabled = isDateDisabled(dayObj.day, dayObj.currentMonth);
          
          // Usa formato locale invece di toISOString() per evitare shift UTC
          const date = new Date(
            currentMonth.getFullYear(),
            currentMonth.getMonth(),
            dayObj.day
          );
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          const dateStr = `${year}-${month}-${day}`;
          
          // Solo i giorni del mese corrente possono essere selezionati
          const isSelected = dayObj.currentMonth && selectedDate === dateStr;

          return (
            <button
              key={index}
              onClick={() => handleSelectDate(dayObj.day)}
              disabled={isDisabled}
              className={`
                py-2 px-1 rounded text-sm font-medium transition
                ${!dayObj.currentMonth ? 'text-gray-300 bg-gray-50 cursor-default' : ''}
                ${isDisabled ? 'text-gray-400 bg-gray-50 cursor-not-allowed' : ''}
                ${dayObj.currentMonth && !isDisabled && !isSelected ? 'text-gray-700 hover:bg-green-50 cursor-pointer' : ''}
                ${isSelected ? 'bg-green-500 text-white font-bold' : ''}
              `}
            >
              {dayObj.day}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default Calendar;
